<div class="shortlisted-page">

  <!-- Page Header -->
  <div class="page-header">
    <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>
    <div>
      <h1>Shortlisted Merchants</h1>
      <p>Merchants you've saved for your wedding.</p>
    </div>

    <div class="count-badge" *ngIf="!loading">
      {{ shortlistedMerchants.length }}
      {{ shortlistedMerchants.length === 1 ? 'Merchant' : 'Merchants' }}
    </div>
  </div>


  <!-- Loading -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading shortlisted merchants...</p>
  </div>


  <!-- Empty State -->
  <div
    class="empty-state"
    *ngIf="!loading && shortlistedMerchants.length === 0"
  >

    <span class="material-symbols-outlined">
      favorite_border
    </span>

    <h3>No shortlisted merchants</h3>

    <p>
      You haven't shortlisted any merchants yet.
    </p>

    <button
      type="button"
      class="browse-btn"
      routerLink="/wedding-services"
    >
      Browse Merchants
    </button>

  </div>


  <!-- Merchant Grid -->
  <div
    class="merchant-grid"
    *ngIf="!loading && shortlistedMerchants.length > 0"
  >

    <div
      class="merchant-card"
      *ngFor="let item of shortlistedMerchants"
    >

      <!-- Merchant Image -->
      <div class="merchant-image">

        <img
  [src]="getMerchantImage(item?.merchant)"
  alt="Merchant"
>


        <!-- Premium -->
        <div
          class="premium-badge"
          *ngIf="item?.merchant?.subscriptionTier === 'PREMIUM'"
        >
          <span class="material-symbols-outlined">
            workspace_premium
          </span>
          Premium
        </div>


        <!-- Remove Shortlist -->
        <button
          type="button"
          class="wishlist-btn shortlisted"
          (click)="removeShortlist(item)"
          title="Remove from shortlist"
        >
          <span class="material-symbols-outlined">
            favorite
          </span>
        </button>

      </div>


      <!-- Merchant Details -->
      <div class="merchant-details">

        <div class="title-row">

          <h3>
            {{
              item?.merchant?.business_name ||
              item?.merchant?.businessName ||
              'Merchant'
            }}
          </h3>

        </div>


        <!-- Category -->
        <div class="category">

  <span class="material-symbols-outlined">
    category
  </span>

  {{ getCategoryName(item?.merchant?.category) }}

</div>


        <!-- Location -->
        <div class="location">

  <span class="material-symbols-outlined">
    location_on
  </span>

  {{ getCityName(item?.merchant?.city) }}

</div>


        <!-- Actions -->
        <div class="action-row">

          <button
            type="button"
            class="view-btn"
            (click)="viewMerchant(item?.merchant?._id)"
          >
            View Profile
          </button>

          <button
            type="button"
            class="remove-btn"
            (click)="removeShortlist(item)"
          >
            Remove
          </button>

        </div>

      </div>

    </div>

  </div>

</div>